// frontend/src/themes/themeConstants.ts
/**
 * Constantes de cores do tema verde menta
 * 
 * Este arquivo centraliza as definições de cores para garantir consistência em todo o aplicativo.
 * Usar estas constantes em vez de valores hardcoded permite fácil manutenção e atualização
 * do esquema de cores.
 * 
 * O tema principal do aplicativo é verde menta (#00BFA5) sobre fundo escuro (#1E1E1E).
 */

export const VERDE_MENTA = "#00BFA5";
export const VERDE_MENTA_ESCURO = "#00897B";
export const VERDE_MENTA_CLARO = "#4ECDB5";

// Cores secundárias
export const LARANJA = "#FF8A65";
export const CIANO = "#00ACC1";

// Cores de background
export const FUNDO_ESCURO = "#1E1E1E";
export const FUNDO_PAPEL = "#2D2D2D";
export const FUNDO_DRAWER = "#252525";
export const FUNDO_CLARO = "#F5F5F5";  // Cinza bem claro
export const FUNDO_CLARO_ALTERNATIVO = "#FAFAFA";  // Ainda mais claro

// Cores para cards e elementos - tons mais suaves
export const FUNDO_CARD = "#363636";    // Para cards e componentes elevados
export const FUNDO_CARD_HOVER = "#404040";   // Para estados hover em cards
export const FUNDO_PROJECT_CARD = "#2A2A2A";  // Para cards individuais de projeto (mais escuro)
export const FUNDO_PROJECT_CARD_HOVER = "#343434";  // Para hover nos project cards
export const FUNDO_TABELA = "#333333";  // Para background de tabelas
export const FUNDO_LINHA_HOVER = "#3A3A3A"; // Para hover em linhas de tabela

// Cores de texto
export const TEXTO_PRIMARIO = "#FFFFFF";
export const TEXTO_SECUNDARIO = "#B0B0B0";
export const TEXTO_ESCURO = "#1A1A1A";  // Para usar em fundos claros
export const TEXTO_ESCURO_SECUNDARIO = "#666666";  // Para textos secundários em fundos claros

// Cores de bordas e divisores
export const BORDA_CARD = "#404040";    // Borda suave para cards
export const BORDA_TABELA = "#3A3A3A";  // Borda para tabelas
export const DIVISOR = "#3A3A3A";      // Para Divider components

// Cores de status
export const SUCESSO = "#66BB6A";
export const ERRO = "#F44336";
export const AVISO = "#FF9800";
export const INFO = "#29B6F6";

// Funções utilitárias para transparência
export const withAlpha = (color: string, alpha: number): string => {
  // Converte o valor de alfa (0-1) para formato hexadecimal ou rgba
  if (alpha >= 0 && alpha <= 1) {
    // Para cores hexadecimais como #RRGGBB
    if (color.startsWith('#') && (color.length === 7 || color.length === 9)) {
      return `${color}${Math.round(alpha * 255).toString(16).padStart(2, '0')}`;
    }
    // Para nomes de cores ou outros formatos, usar rgba
    return `rgba(${hexToRgb(color)}, ${alpha})`;
  }
  return color;
};

// Função auxiliar para converter hex para rgb
const hexToRgb = (hex: string): string => {
  // Remover o # se existir
  hex = hex.replace(/^#/, '');
  
  // Expandir formato curto (exemplo: #03F) para formato completo (exemplo: #0033FF)
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  
  // Converter para RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  return `${r}, ${g}, ${b}`;
};